/* Scheduled-maintenance notice (2026-10-11). Shown on every page while
   `now` is between `showFrom` and `hideAfter`, then it hides itself: no
   second deploy is needed to take it down. Times carry their offset (EAT,
   +03:00), so every visitor's clock agrees on them.

   The release run sheet (ops/2026-10-10-release-run-sheet.md) posts the
   notice the day before and takes it down after the window. If the release
   moves, change these three values; with no window at all, set
   MAINTENANCE_NOTICE to null. */
export const MAINTENANCE_NOTICE = {
  showFrom: "2026-10-12T00:00:00+03:00",
  hideAfter: "2026-10-13T07:00:00+03:00",
  text: "Scheduled maintenance: Tuesday 13 October, 06:00–06:30 EAT. Emporia may be unavailable for a few minutes. Your cart and wishes are safe.",
};

export function maintenanceNoticeActive(now = new Date(), notice = MAINTENANCE_NOTICE) {
  if (!notice) return false;
  const t = now.getTime();
  return t >= Date.parse(notice.showFrom) && t < Date.parse(notice.hideAfter);
}
